// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"d228eec2","453":"c83a5292","796":"eb5570cf"}[chunkId] + ".chunk.js";
};